import { MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';

export const CUSTOM_DATE_FORMATS = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    monthYearLabel: { year: 'numeric', month: 'long' }
  }
};
